const colors = {
  black: '#222',
  black2: '#030303',
  blackLight: '#2c2c2c',
  blackLight2: '#121212',
  blackPure: '#000',
  white: '#fff',
  transparent: 'transparent',
  gray: '#ccc',
  grayDark: '#787878',
  grayLight: '#f4f4f4',
  grayPorcelain: '#f3f4f5',
  greenSuccess: '#78b627',
  green: '#6d8968',
  green2: '#647D5E',
  greenDark: '#465049',
  greenLight: '#c2d4a1',
  blueLight: '#8cccd6',
  blueDark: '#32818e',
  brown: '#523714',
  brownLight: '#a46c14',
  gold: '#af8d40',
  yellow: '#F2BA43',
  goldLight: '#F2BA43',
  silver: '#B4B4B4',
  bronze: '#E48D5C',
  orange: '#E48D5C',
  purple: '#8c6d9f',
  red: '#c42f29'
};
export { colors };